export const contact = {
  email: "t.ferfce@gmail.com",
  phone: "+306979156915",
  linkedin: "https://www.linkedin.com/in/thomas-ferfelis-351a95109/",
  github: "https://github.com/tferfce",
};
